"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.setModularGridUnit = setModularGridUnit;
exports.getModularGridUnit = getModularGridUnit;
var modular_grid_unit = void 0;

function setModularGridUnit(unit) {
	modular_grid_unit = unit;
}

function getModularGridUnit() {
	return modular_grid_unit;
}
//# sourceMappingURL=grid.js.map